import React from "react";
import { connect } from "react-redux";

import DashboardAdd from "../../Components/Layouts/DashboardAdd";
import TestimonialForm from "../../Components/Forms/TestimonialForm";
import { createEntity, updateEntityInfo, setUpdatedRecentlyToFalse } from "../../Redux/TestimonialForm/actions";
import { getEntityById } from "../../Redux/Page/actions";

function Add({ useAuth, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm }) {
  return (
    <DashboardAdd useAuth={useAuth}>
        <TestimonialForm
          isAddForm
          {...{getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}}
        />
    </DashboardAdd>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.testimonial,
    selectedForm: state.testimonialForm,
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEntityById: (tokenData, id) => dispatch(getEntityById(tokenData, id)),
    createEntity: (formData, tokenData, exitAfter, history) => dispatch(createEntity(formData, tokenData, exitAfter, history)),
    updateEntityInfo: (formData, tokenData, id) => dispatch(updateEntityInfo(formData, tokenData, id)),
    setUpdatedRecentlyToFalse: () => dispatch(setUpdatedRecentlyToFalse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Add);
